import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import Popup from "reactjs-popup";
import SlidingPane from "react-sliding-pane";

import UserMenu from '../../UserMenu/components/UserMenu';
import { Conductor } from '@opendate-app/setlist';
import OpendateLogo from '../../shared/Icons/OpendateLogo';
import UnreadDot from '../../shared/components/UnreadDot';

const popupContentStyle = {
  "background": "var(--od-c-fafafa, #fafafa)",
  "border": "1px solid var(--od-c-e9eaeb, #E9EAEB)",
  "borderRadius": "12px",
  "boxShadow": "0px 12px 16px -4px rgba(10, 13, 18, 0.08), 0px 4px 6px -2px rgba(10, 13, 18, 0.03), 0px 2px 2px -1px rgba(10, 13, 18, 0.04)",
  "width": "calc(100% - 30px)",
  "padding": "0px",
  "overflow": "hidden",
  "zIndex": "999"
}

const axios = require('axios').default;

const MobileMenu = ({
  csrfToken,
  currentUser,
  team,
  menuLinks,
  teamMemberships,
  settingsLink,
  helpLink,
  myTicketsLink,
  updatesLink,
  isGuest,
  myEventsPath
}) => {
  const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = (
      typeof(window) !== 'undefined' ? window : { innerWidth: 0, innerHeight: 0 }
    );

    return {
      width,
      height
    };
  }

  const [isMounted, setIsMounted] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    setWindowDimensions(getWindowDimensions());

    var handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if(windowDimensions.width > 575 && menuOpen) {
      setMenuOpen(false);
    }
  }, [windowDimensions]);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const effectiveMenuLinks = isGuest
    ? [{
        toolTip: "My Events",
        href: myEventsPath,
        active: typeof window !== 'undefined' && window.location.pathname === myEventsPath,
        xlinkHref: "#myEvents"
      }]
    : menuLinks;

  return (
    <div className="row"
          style={{"background": "var(--od-c-ffffff, white)"}}>
      <div className="col-12 d-flex justify-content-between align-items-center"
            style={{"borderBottom": "2px solid var(--od-c-e9eaeb, #E9EAEB)"}}>
        {/* height + margins reproduce the old PNG's visible content and
            transparent padding at maxWidth 150px, keeping the header height */}
        <OpendateLogo height={30}
              style={{"margin": "12px 0"}} />
        <a href="#"
            onClick={() => setMenuOpen(true)}
            style={{"fontSize": "21px"}}
            className="text-dark">
          <i className="fal fa-bars"
              aria-hidden></i>
        </a>
      </div>
      <SlidingPane
        isOpen={menuOpen}
        from="left"
        className="sliding-pane-menu-container"
        overlayClassName="sliding-pane-menu-overlay"
        hideHeader={true}
        onRequestClose={() => {
          setMenuOpen(false);
        }}
      >
        <div className="d-flex flex-column h-100">
          {/* the old PNG box was -10px/6px margins + ~12px transparent padding
              on each side; 2px/18px keeps the visible logo in the same spot */}
          <OpendateLogo height={30}
                style={{
                  "marginTop": "2px",
                  "marginBottom": "18px"
                }} />
          <div className="flex-grow-1 d-flex flex-column"
                style={{
                  overflowX: "hidden",
                  overflowY: "auto",
                  scrollbarWidth: "none"
                }}>
            <div className='flex-grow-1'>
              {effectiveMenuLinks.map((link, index) => (
                <div key={index}
                      className='d-flex align-items-center position-relative main-menu-link'
                      style={{
                        "padding": "10px 8px",
                        "borderRadius": "4px",
                        "marginBottom": "2px",
                        "background": (link.active ? "var(--od-c-fafafa, #fafafa)" : "transparent")
                      }}>
                  <a href={link.href}
                      className='stretched-link text-dark d-flex'>
                    <div className='d-flex align-items-center justify-content-center position-relative'
                          style={{"width": "17px"}}>
                      {link.toolTip === 'CRM' ? (
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 24 24"
                          fill="none"
                          aria-hidden="true"
                        >
                          <path
                            d="M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
                            style={{ stroke: 'var(--od-c-717680, #717680)' }}
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      ) : (
                        <svg className="sprite-icon"
                              style={{
                                "width": "17px",
                                "height": "17px"
                              }}>
                          <use xlinkHref={link.xlinkHref}></use>
                        </svg>
                      )}
                      {link.unread && <UnreadDot label={link.unreadLabel} />}
                    </div>
                    <span className="mb-0"
                        style={{
                          "marginLeft": "13px",
                          "fontSize": "16px",
                          "fontWeight": "600"
                        }}>
                      {link.toolTip}
                    </span>
                  </a>
                </div>
              ))}
            </div>
            <div className='d-flex flex-column'>
              {team.package?.ai_features && !isGuest ? (
                <div className='d-flex align-items-center position-relative main-menu-link'
                      style={{
                        "padding": "10px 8px",
                        "borderRadius": "4px",
                        "marginBottom": "2px",
                        "background": "transparent",
                        "cursor": "pointer"
                      }}
                      data-conductor-launcher="true"
                      onClick={() => {
                        setMenuOpen(false);
                        window.dispatchEvent(new CustomEvent('openConductor', { detail: { source: 'mobile_menu' } }));
                      }}>
                  <div className='d-flex align-items-center justify-content-center'
                        style={{"width": "17px"}}>
                    <Conductor className="conductor-nav-icon" width={17} height={17} />
                  </div>
                  <span className="mb-0"
                        style={{
                          "marginLeft": "13px",
                          "fontSize": "16px",
                          "fontWeight": "600",
                          "color": "var(--od-c-111827, #111827)"
                        }}>
                    Conductor
                  </span>
                </div>
              ) : null}
              {Object.keys(myTicketsLink).length > 0 ? (
                <div className='d-flex align-items-center position-relative main-menu-link'
                      style={{
                        "padding": "10px 8px",
                        "borderRadius": "4px",
                        "marginBottom": "2px",
                        "background": (myTicketsLink.active ? "var(--od-c-fafafa, #fafafa)" : "transparent")
                      }}>
                  <a href={myTicketsLink.href}
                      className='stretched-link text-dark d-flex'>
                    <div className='d-flex align-items-center justify-content-center'
                        style={{"width": "17px"}}>
                      <svg className="sprite-icon"
                            style={{
                              "width": "17px",
                              "height": "17px"
                            }}>
                        <use xlinkHref={myTicketsLink.xlinkHref}></use>
                      </svg>
                    </div>
                    <span className="mb-0"
                          style={{
                            "marginLeft": "13px",
                            "fontSize": "16px",
                            "fontWeight": "600"
                          }}>
                      {myTicketsLink.toolTip}
                    </span>
                  </a>
                </div>
              ) : null}
              {Object.keys(updatesLink).length > 0 ? (
                <div className='d-flex align-items-center position-relative main-menu-link'
                      style={{
                        "padding": "10px 8px",
                        "borderRadius": "4px",
                        "marginBottom": "2px",
                        "background": (updatesLink.active ? "var(--od-c-fafafa, #fafafa)" : "transparent")
                      }}>
                  <a href={updatesLink.href}
                      className='stretched-link text-dark d-flex'>
                    <div className='d-flex align-items-center justify-content-center position-relative'
                        style={{"width": "17px"}}>
                      <svg className="sprite-icon"
                            style={{
                              "width": "17px",
                              "height": "17px"
                            }}>
                        <use xlinkHref={updatesLink.xlinkHref}></use>
                      </svg>
                      {updatesLink.unread && <UnreadDot />}
                    </div>
                    <span className="mb-0"
                          style={{
                            "marginLeft": "13px",
                            "fontSize": "16px",
                            "fontWeight": "600"
                          }}>
                      {updatesLink.toolTip}
                    </span>
                  </a>
                </div>
              ) : null}
              {Object.keys(helpLink).length > 0 ? (
                <div className='d-flex align-items-center position-relative main-menu-link'
                      style={{
                        "padding": "10px 8px",
                        "borderRadius": "4px",
                        "marginBottom": "2px",
                        "background": (helpLink.active ? "var(--od-c-fafafa, #fafafa)" : "transparent")
                      }}>
                  <a href={helpLink.href}
                      className='stretched-link text-dark d-flex'>
                    <div className='d-flex align-items-center justify-content-center'
                        style={{"width": "17px"}}>
                      <svg className="sprite-icon"
                            style={{
                              "width": "17px",
                              "height": "17px"
                            }}>
                        <use xlinkHref={helpLink.xlinkHref}></use>
                      </svg>
                    </div>
                    <span className="mb-0"
                          style={{
                            "marginLeft": "13px",
                            "fontSize": "16px",
                            "fontWeight": "600"
                          }}>
                      {helpLink.toolTip}
                    </span>
                  </a>
                </div>
              ) : null}
              {Object.keys(settingsLink).length > 0 ? (
                <div className='d-flex align-items-center position-relative main-menu-link'
                      style={{
                        "padding": "10px 8px",
                        "borderRadius": "4px",
                        "marginBottom": "2px",
                        "background": (settingsLink.active ? "var(--od-c-fafafa, #fafafa)" : "transparent")
                      }}>
                  <a href={settingsLink.href}
                      className='stretched-link text-dark d-flex'>
                    <div className='d-flex align-items-center justify-content-center'
                        style={{"width": "17px"}}>
                      <svg className="sprite-icon"
                            style={{
                              "width": "17px",
                              "height": "17px"
                            }}>
                        <use xlinkHref={settingsLink.xlinkHref}></use>
                      </svg>
                    </div>
                    <span className="mb-0"
                          style={{
                            "marginLeft": "13px",
                            "fontSize": "16px",
                            "fontWeight": "600"
                          }}>
                      {settingsLink.toolTip}
                    </span>
                  </a>
                </div>
              ) : null}
            </div>
          </div>
          <Popup arrow={false}
                offsetY={6}
                offsetX={0}
                position="top left"
                contentStyle={popupContentStyle}
                onOpen={
                  (e) => {
                    e.preventDefault();
                  }
                }
                trigger={open => (
                  <div className='d-flex position-relative'
                        style={{
                          "border": "1px solid var(--od-c-e9eaeb, #E9EAEB)",
                          "borderRadius": "8px",
                          "marginTop": "10px",
                          "padding": "11px 5px 11px 11px"
                        }}>
                    <div className='position-relative'>
                      <img src={currentUser.avatar_thumb_url}
                            className='img-fluid rounded-circle'
                            style={{"width": "40px", "height": "40px"}} />
                      <div className='rounded-circle position-absolute'
                            style={{
                              "width": "10px",
                              "height": "10px",
                              "background": "#A2DC47",
                              "border": "1.5px solid var(--od-c-ffffff, #ffffff)",
                              "bottom": "0px",
                              "right": "0px"
                            }}>
                      </div>
                    </div>
                    <div className='flex-grow-1'
                          style={{"marginLeft": "10px"}}>
                      <div style={{"maxWidth": "250px"}}>
                        <p className='mb-0 text-truncate' style={{"fontWeight": "600"}}>
                          {currentUser.first_name} {currentUser.last_name}
                        </p>
                      </div>
                      <div style={{"maxWidth": "250px"}}>
                        <p className='mb-0 text-muted text-truncate' style={{"marginTop": "-3px"}}>
                          {currentUser.email}
                        </p>
                      </div>
                    </div>
                    <a href="#"
                        className='main-menu-link d-flex flex-column align-items-center text-muted align-self-start stretched-link'
                        style={{
                          "textDecoration": "none",
                          "padding": "5px 9px",
                          "borderRadius": "8px",
                          "marginTop": "-5px"
                        }}
                        onClick={
                          (e) => {
                            e.preventDefault();
                          }
                        }>
                      <i className="far fa-angle-up"
                          aria-hidden></i>
                      <i className="far fa-angle-down"
                          aria-hidden
                          style={{"marginTop": "-5px"}}></i>
                    </a>
                  </div>
                )} >
            {close => (
              <UserMenu csrfToken={csrfToken}
                        currentUser={currentUser}
                        team={team}
                        teamMemberships={teamMemberships} />
            )}
          </Popup>
        </div>
      </SlidingPane>
    </div>
  )
};

MobileMenu.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  currentUser: PropTypes.object.isRequired,
  team: PropTypes.object.isRequired,
  menuLinks: PropTypes.array.isRequired,
  teamMemberships: PropTypes.array.isRequired,
  settingsLink: PropTypes.object,
  helpLink: PropTypes.object,
  myTicketsLink: PropTypes.object,
  updatesLink: PropTypes.object,
  isGuest: PropTypes.bool,
  myEventsPath: PropTypes.string,
};

export default MobileMenu;
